(function () {
  if (window.__IRONSIDE_UGC_CAROUSEL_V15__) return;
  window.__IRONSIDE_UGC_CAROUSEL_V15__ = true;

  function buildIframe(videoId) {
    return '<iframe src="https://www.youtube.com/embed/' +
      videoId +
      '?autoplay=1&playsinline=1&rel=0&modestbranding=1&controls=1&showinfo=0" ' +
      'title="YouTube video" loading="eager" ' +
      'allow="autoplay; encrypted-media; picture-in-picture; clipboard-write; web-share" ' +
      'allowfullscreen></iframe>';
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function moveLightboxToBody(section, lightbox) {
    if (!lightbox || lightbox.dataset.ugcMovedToBody === 'true') return;
    document.body.appendChild(lightbox);
    lightbox.dataset.ugcMovedToBody = 'true';
    lightbox.dataset.ugcOwnerId = section.dataset.ugcSectionId || '';
  }

  function initSection(section, idx) {
    if (!section || section.dataset.ugcReady === 'true') return;
    section.dataset.ugcReady = 'true';
    if (!section.dataset.ugcSectionId) {
      section.dataset.ugcSectionId = 'ugc-' + idx + '-' + Date.now();
    }

    var track = section.querySelector('[data-ironside-ugc-track]');
    var lightbox = section.querySelector('[data-ironside-ugc-lightbox]');
    var videoContainer = section.querySelector('[data-ironside-ugc-lightbox-video]');
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-ironside-ugc-open]'));
    var closes = section.querySelectorAll('[data-ironside-ugc-close]');
    var swipeArea = section.querySelector('[data-ironside-ugc-swipe-area]');
    var nextBtns = section.querySelectorAll('[data-ironside-ugc-next]');
    var prevBtns = section.querySelectorAll('[data-ironside-ugc-prev]');
    var carouselNextBtn = section.querySelector('[data-ironside-ugc-carousel-next]');
    var counter = section.querySelector('[data-ironside-ugc-counter]');

    if (!track || !lightbox || !videoContainer || !buttons.length) return;

    moveLightboxToBody(section, lightbox);

    closes = lightbox.querySelectorAll('[data-ironside-ugc-close]');
    swipeArea = lightbox.querySelector('[data-ironside-ugc-swipe-area]');
    nextBtns = lightbox.querySelectorAll('[data-ironside-ugc-next]');
    prevBtns = lightbox.querySelectorAll('[data-ironside-ugc-prev]');
    counter = lightbox.querySelector('[data-ironside-ugc-counter]');

    var currentIndex = 0;
    var swipeThreshold = 50;

    var dragStartX = 0;
    var dragStartY = 0;
    var isDraggingTrack = false;
    var suppressClickUntil = 0;

    var modalStartX = 0;
    var modalStartY = 0;

    var loaderTimeout = null;
    var MIN_LOADER_DELAY = 180;

    function getLoader() {
      return lightbox.querySelector('[data-ironside-ugc-loader]');
    }

    function resetVideoContainer() {
      videoContainer.innerHTML = '<div class="ironside-ugc-loader" data-ironside-ugc-loader><span class="ironside-ugc-spinner"></span></div>';
    }

    function setModalState(open) {
      if (open) {
        section.setAttribute('data-ugc-modal-open', 'true');
        document.documentElement.classList.add('ironside-ugc-modal-open');
        document.body.classList.add('ironside-ugc-modal-open');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      } else {
        section.removeAttribute('data-ugc-modal-open');
        document.documentElement.classList.remove('ironside-ugc-modal-open');
        document.body.classList.remove('ironside-ugc-modal-open');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }

    function normalizeIndex(index) {
      if (index < 0) return buttons.length - 1;
      if (index >= buttons.length) return 0;
      return index;
    }

    function getScrollStep() {
      var firstCard = section.querySelector('[data-ironside-ugc-card]');
      if (!firstCard) return track.clientWidth * 0.8;
      var gap = parseFloat(window.getComputedStyle(track).gap || 0);
      return firstCard.offsetWidth + gap;
    }

    function updateCarouselNextState() {
      if (!carouselNextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      carouselNextBtn.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function centerCard(index) {
      var btn = buttons[index];
      if (!btn) return;

      var card = btn.closest('[data-ironside-ugc-card]');
      if (!card) return;

      var left = card.offsetLeft;
      var width = card.offsetWidth;
      var target = left - (track.clientWidth / 2) + (width / 2);

      track.scrollTo({
        left: Math.max(0, target),
        behavior: 'smooth'
      });
    }

    function updateCounter() {
      if (!counter) return;
      counter.textContent = (currentIndex + 1) + ' / ' + buttons.length;
    }

    function render(index) {
      currentIndex = normalizeIndex(index);

      var id = buttons[currentIndex].getAttribute('data-video-id');

      if (loaderTimeout) {
        clearTimeout(loaderTimeout);
        loaderTimeout = null;
      }

      var loader = getLoader();
      if (loader) loader.classList.remove('active');

      loaderTimeout = setTimeout(function () {
        var delayedLoader = getLoader();
        if (delayedLoader) delayedLoader.classList.add('active');
      }, MIN_LOADER_DELAY);

      resetVideoContainer();
      videoContainer.insertAdjacentHTML('afterbegin', buildIframe(id));

      var iframe = videoContainer.querySelector('iframe');
      if (iframe) {
        iframe.onload = function () {
          if (loaderTimeout) {
            clearTimeout(loaderTimeout);
            loaderTimeout = null;
          }
          var activeLoader = getLoader();
          if (activeLoader) activeLoader.classList.remove('active');
        };
      }

      updateCounter();
      centerCard(currentIndex);
    }

    function open(index) {
      lightbox.hidden = false;
      setModalState(true);
      render(index);

      requestAnimationFrame(function () {
        lightbox.classList.add('active');
      });
    }

    function close() {
      lightbox.classList.remove('active');

      setTimeout(function () {
        lightbox.hidden = true;
        resetVideoContainer();
      }, 250);

      if (loaderTimeout) {
        clearTimeout(loaderTimeout);
        loaderTimeout = null;
      }

      var loader = getLoader();
      if (loader) loader.classList.remove('active');

      setModalState(false);
    }

    function next() {
      render(currentIndex + 1);
    }

    function prev() {
      render(currentIndex - 1);
    }

    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function (e) {
        if (Date.now() < suppressClickUntil || isDraggingTrack) {
          e.preventDefault();
          return;
        }
        open(index);
      });
    });

    closes.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', next);
    });

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', prev);
    });

    if (carouselNextBtn) {
      carouselNextBtn.addEventListener('click', function () {
        track.scrollBy({
          left: getScrollStep() * 2,
          behavior: 'smooth'
        });
      });
    }

    track.addEventListener('scroll', updateCarouselNextState, { passive: true });
    window.addEventListener('resize', updateCarouselNextState);
    updateCarouselNextState();

    track.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      dragStartX = e.touches[0].clientX;
      dragStartY = e.touches[0].clientY;
      isDraggingTrack = false;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;
      var dx = Math.abs(e.touches[0].clientX - dragStartX);
      var dy = Math.abs(e.touches[0].clientY - dragStartY);

      if (dx > 10 && dx > dy * 1.1) {
        isDraggingTrack = true;
        suppressClickUntil = Date.now() + 250;
      } else if (dy > dx) {
        isDraggingTrack = false;
      }
    }, { passive: true });

    track.addEventListener('touchend', function () {
      setTimeout(function () {
        isDraggingTrack = false;
      }, 50);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;

      if (e.key === 'Escape') close();
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next();
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') prev();
    });

    if (swipeArea) {
      swipeArea.addEventListener('touchstart', function (e) {
        if (lightbox.hidden || !e.touches || !e.touches.length) return;
        modalStartX = e.touches[0].clientX;
        modalStartY = e.touches[0].clientY;
      }, { passive: true });

      swipeArea.addEventListener('touchend', function (e) {
        if (lightbox.hidden || !e.changedTouches || !e.changedTouches.length) return;

        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var dx = endX - modalStartX;
        var dy = endY - modalStartY;

        if (isMobileViewport()) {
          if (Math.abs(dx) < swipeThreshold || Math.abs(dx) <= Math.abs(dy)) return;
          if (dx < 0) next();
          else prev();
        } else {
          if (Math.abs(dy) < swipeThreshold) return;
          if (dy < 0) next();
          else prev();
        }
      }, { passive: true });
    }

    resetVideoContainer();
  }

  function initAll() {
    document.querySelectorAll('[data-ironside-ugc-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-ironside-ugc-section]').forEach(initSection);
  });
})();